export const items = [
  {
    id: 'settings',
    title: 'Settings',
    icon: 'IconSettings',
    path: '/settings',
    flavour: 'sloyd-only',
  },
  {
    id: 'account',
    title: 'Account',
    icon: 'IconUser',
    path: '/account',
  },
  {
    id: 'usage',
    title: 'Usage',
    icon: 'IconList',
    path: '/usage',
    flavour: 'hidden',
  },
  {
    id: 'logout',
    title: 'Logout',
    icon: 'IconLogout',
    path: '/logout',
  },
];
